export default {
  cloneObject(o) {
    //recursiveDeepCopy from -https://jsperf.com/deep-copy-vs-json-stringify-json-parse/5
    if (typeof o !== 'object') return o;
    if (!o) return o;

    let newO, i;
    const type = Object.prototype.toString.apply(o);

    if ('[object Array]' === type) {
      newO = [];
      for (i = 0; i < o.length; i += 1) {
        newO[i] = this.cloneObject(o[i]);
      }
      return newO;
    } else if ('[object Date]' === type) {
      return new Date(o.getTime());
    }


    newO = {};
    for (i in o) {
      // eslint-disable-next-line no-prototype-builtins
      if (o.hasOwnProperty(i)) {
        newO[i] = this.cloneObject(o[i]);
      }
    }
    return newO;
  },
}